import React from 'react'
import PropTypes from 'prop-types'
import {wissensportalEnums} from 'ag-common/tools/wissensportal'
import Circle from '#components/svg/icons/Circle'
import InProgressCircle from '#components/svg/icons/InProgressCircle'
import CheckMark from '#components/svg/icons/CheckMark'

function renderStatusIcon(status) {
  switch (status) {
    case wissensportalEnums.NOT_STARTED:
      return <Circle />
    case wissensportalEnums.IN_PROGRESS:
      return <InProgressCircle />
    case wissensportalEnums.FINISHED:
      return <CheckMark />
    default:
      return null
  }
}

function Module({name, status, modules, type}) {
  return (
    <div className="module">
      {renderStatusIcon(status)}
      <span>{name}</span>
      {type === 'FOLDER' && modules && (
        <div className="module__submodules">
          {modules.map(module => (
            <Module {...module} key={module.id} />
          ))}
        </div>
      )}
    </div>
  )
}

Module.propTypes = {
  name: PropTypes.string,
  status: PropTypes.oneOf(['NOT_STARTED', 'IN_PROGRESS', 'FINISHED']),
  type: PropTypes.oneOf(['FOLDER', 'COURSE_MODULE', 'COURSE']),
  modules: PropTypes.array,
}

export default Module
